export const useStyles = (theme) => ({
  fieldStyle: {
    display: "flex",
    [theme.breakpoints.down(650)]: {
      flexDirection: "column",
    },
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bold",
    backgroundColor: "#f9f9fb",
    paddingRight: 10,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
});
